/*
 * @Author: jikeychang@gmail.com
 * @Date: 2021-03-04 11:12:47
 * @LastEditors: jikeychang@gmail.com
 * @LastEditTime: 2021-03-04 11:14:52
 * @Description: FileDescription
 */
/*
 * @Description: ums-用户管理系统-组织管理store
 * @Author: jikeyChang
 * @Date: 2019-08-26 16:18:31
 * @LastEditTime: 2019-08-26 17:05:00
 * @LastEditors: Please set LastEditors
 */

import dbc from '@/api/organizeManageTow';

export default {
  namespaced: true,

  state: {
    departmentTree: [],
    departmentDetail: {},
    deleteDepartmentsMsg: {
      total: 0,
    },
    deleteDepartmentConfig: {
      keyword: '',
      pageNum: 1,
      pageSize: 10,
    },
    roleConfig: [],
  },
  actions: {
    // 获取:部门树
    getDepartmentTree({ commit }, param = { souce: '' }) {
      return dbc
        .getDepartmentTree(param)
        .then((result) => {
          commit('setDepartmentTree', result.list);
        })
        .catch(() => ({ success: false, message: '网络有误' }));
    },
    // 获组织详情
    async getDepartmentDetail({ commit }, param) {
      const data = await dbc.getDepartmentDetail(param);
      commit('setDepartmentDetail', { data: data.data, id: param.id });
    },
    // 获取已删除部门
    async getDeleteDepartments({ commit, state }, param) {
      const obj = Object.assign(state.deleteDepartmentConfig, param);
      commit('setDeleteDepartmentConfig', obj);
      await dbc
        .getDeleteDepartments(obj)
        .then((result) => {
          commit('setDeleteDepartmentsMsg', result.page);
        })
        .catch(() => ({ success: false, message: '网络有误' }));
    },
    // 新增组织
    async createDepartment(store, param) {
      const result = await dbc
        .createDepartment(param)
        .catch(() => ({ success: false, message: '网络有误' }));
      return result;
    },
    // 编辑组织
    async editDepartment(store, param) {
      return dbc.editDepartment(param).catch(() => ({ success: false, message: '网络有误' }));
    },
    // 删除组织
    async deleteDepartment(store, param) {
      const result = await dbc
        .deleteDepartment(param)
        .catch(() => ({ success: false, message: '网络有误' }));
      return result;
    },
    // 获取角色
    async getRoleSources({ commit }, param) {
      const result = await dbc.getRoleSources(param);
      commit('setRoleConfig', result.page.list);
    },
  },
  mutations: {
    // 设置获取删除部门请求参数
    setDeleteDepartmentConfig(state, content) {
      state.deleteDepartmentConfig = content;
    },
    // 设置角色
    setRoleConfig(state, content) {
      state.roleConfig = content;
    },
    /**
     * 预算部门
     */
    setDepartmentTree(state, content) {
      state.departmentTree = content;
    },
    // 组织详情
    setDepartmentDetail(state, content) {
      state.departmentDetail = content.data;
      state.departmentDetail.deptCode = content.id;
    },
    // 已删除部门
    setDeleteDepartmentsMsg(state, content) {
      console.log(content);
      state.deleteDepartmentsMsg = content;
    },
  },
};
